import { Component } from 'react';
import Raven from 'raven-js';
import { GenericErrorState } from './GenericErrorState';
import { jsx as _jsx } from "react/jsx-runtime";
export class PageErrorBoundary extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      hasError: false
    };
  }
  static getDerivedStateFromError() {
    return {
      hasError: true
    };
  }
  componentDidCatch(error, errorInfo) {
    Raven.captureException(error, {
      extra: {
        componentStack: errorInfo.componentStack
      }
    });
  }
  render() {
    if (this.state.hasError) {
      return /*#__PURE__*/_jsx(GenericErrorState, {});
    }
    return this.props.children;
  }
}